import { createRouter, createWebHistory, RouteLocationNormalized } from 'vue-router'
import CONSTANTS from '@/constants'
import { sendToHubspot } from '@/utils'
import routes from './routes'
import store from '../store'

const Router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  scrollBehavior: (to, from, savedPosition) => {
    if (savedPosition) {
      return savedPosition
    }
    if (to.hash) {
      return {
        el: to.hash,
      }
    }
    return { left: 0, top: 0 }
  },
  routes,
})

Router.afterEach((to, from) => {
  sendToHubspot(to.fullPath)
})

Router.beforeResolve(
  (to: RouteLocationNormalized, from: RouteLocationNormalized, next: Function) => {
    const hasShopped = store.state.shoppingCart.shoppingCart.length > 0

    if (
      !hasShopped &&
      typeof to.name === 'string' &&
      CONSTANTS.ROUTING_RULES.MUST_HAVE_SHOPPED.includes(to.name)
    ) {
      next({ name: 'shop' })
    } else {
      next()
    }
  }
)

export default Router
